import React, { useState, useEffect, useMemo} from 'react';
import { Form, Button } from 'react-bootstrap';
import { useMsal } from "../../Auth/msal-context";
import moment from 'moment';
import { toast } from 'react-toastify';

import Auth from "../../Auth/Auth";

const auth = new Auth();

export default function UPDRequest(props){
    const [ hasPendingChange, setHasPendingChange ] = useState(false);
    const [ isRequesting, setIsRequesting ] = useState(false);
    
    const [ supportApp, setSupportApp ] = useState([]);
    const [ availableWaves, setAvailableWaves ] = useState([]);  
    const [ changeReasonArr, setChangeReasonArr ] = useState([]);

    const [ pendingChange, setPendingChange ] = useState([]);
    const [ selectedWave, setSelectedWave ] = useState("Select");
    const [ selectedWaveDate, setSelectedWaveDate ] = useState("");
    const [ changeReason, setChangeReason ] = useState("");
    const [ changeRequestor, setChangeRequestor ] = useState("");
    const [ changeComment, setChangeComment ] = useState("");
    const [ changeRequestorGUID, setChangeRequestorGUID ] = useState("");
    const [ changeRequestId, setChangeRequestId ] = useState(null);
    

    const { user } = useMsal();

    useEffect(() => {
        if(props.chosenSupportApp !== supportApp){
            setSupportApp(props.chosenSupportApp);
        }
    },[props.chosenSupportApp])

    useEffect(() => {
        if(props.availableWaves !== availableWaves){
            setAvailableWaves(props.availableWaves);
        }
    },[props.availableWaves]);

    useEffect(() => {
        if(props.pendingChange !== pendingChange){
            if(props.pendingChange){
                let change = props.pendingChange[0];
                if(change){
                    setPendingChange(change);
                    setHasPendingChange(true);
                    setSelectedWave(change.RequestedWave);
                    setSelectedWaveDate(change.RequestedMigrationDate);
                    setChangeReason(change.SubmitterComment);
                    setChangeRequestor(change.SubmittedBy);
                    setChangeRequestorGUID(change.SubmittedByGUID);
                    setChangeRequestId(change.ClientWaveChangeRequestId);
                }

            } else {
                setHasPendingChange(false);
            }            
        }
    },[props.pendingChange]);
    
    useEffect(() => {
        if(props.changeReasonArr !== changeReasonArr){
            setChangeReasonArr(props.changeReasonArr);
        }
    },[props.changeReasonArr]);
    
    const changeWave = (wave) => {
        if(wave === "Select"){
            setSelectedWave("Select");
            return;
        }

        let selectedWaveData = availableWaves.filter(el => el.ReleaseKeyEventId.toString() === wave);
        if(selectedWaveData.length){
            setSelectedWave(selectedWaveData[0].ReleaseKeyEventId);
            setSelectedWaveDate(selectedWaveData[0].WaveDate || null);
        }       

    };

    const requestWaveChange = async () => {
        setIsRequesting(true);
        let accessToken = await auth.getToken();

        let requestData = {
            ClientId: supportApp[0].ClientId,
            RequestedReleaseKeyEventId: selectedWave,
            RequestedMigrationDate: selectedWaveDate,
            Comment: changeComment,
            ChangeRequestReasonID: changeReason
        };

        fetch('/api/requestWaveChange', {
            method : "POST",
            headers : {
                'Authorization': "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData)
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            setIsRequesting(false);
            if(data.OutPut.indexOf("Success") > -1){
                props.closeModal();
                toast(`😁 Request has been sent`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            } else {
                toast.error(`👎 ${data.OutPut}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });
        
    };

    const cancelRequest = async () => {
        let accessToken = await auth.getToken();

        let requestData = {
            RequestId: changeRequestId,
            ActionId: 2,
            Comment: "Requestor cancelled request",
        };

        fetch('/api/requestWaveChangeAction', {
            method : "POST",
            headers : {
                'Authorization': "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData)
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            if(data.OutPut.indexOf("Error") < 0){
                toast(`😁 Request has been cancelled`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                setHasPendingChange(false);
                props.closeModal();                        
            } else {
                toast.error(`👎 ${data.OutPut}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });

    };

    return (
        <div id="upd-change-modal">
            {supportApp.map((item,index) => 
                <div key={index}>
                    <h4>{item.ClientName}</h4>
                    <label>Current Wave</label>
                    <p>{item.Wave}</p>
                    <label>Current Date</label>
                    <p>{moment.utc(item.MigrationDate_Local).format('ll')}</p>
                    {!hasPendingChange && (
                        <>
                        <label>Requester</label>
                        <p><small>{user.username}</small></p>
                        </>
                    )}
                    
                    {!hasPendingChange && (
                        <>
                        <div className="mt-4 mb-2 change-request-box">
                            <p>To change the upgrade date please select a wave from below:</p>
                            <label>Requested Wave</label>
                            <Form.Control as="select" className="mb-1" value={selectedWave} onChange={(e) => changeWave(e.target.value)}>
                                <option value="Select">Select</option>
                                {availableWaves.map((item,index) => 
                                    <option value={item.ReleaseKeyEventId.toString()} key={index}>{item.Wave}</option>
                                )}
                            </Form.Control>
                            <p style={{ fontSize: "12px", fontWeight: 300}}>For a non-standard date request not assigned to a wave, please submit your request via D365 &gt; Cloud OPs &gt; Production Schedule Change Request.</p>
                            <p style={{ fontSize: "12px", fontWeight: 300}}>Review this Wiki for detail: <a href="https://ceridian.atlassian.net/l/cp/C5TuEmzu" target="_blank">Exceptional Date Request Wiki</a></p>

                            {selectedWave !== "Select" && (
                                <>                                
                                    <label>Requested Date</label>
                                    {!selectedWaveDate ?
                                        <input type="date" id="start" name="trip-start" value={moment.utc(selectedWaveDate).format("YYYY-MM-DD").toString()} onChange={(e) => setSelectedWaveDate(e.target.value)} min={moment().utc().format("YYYY-MM-DD").toString()} />                                   
                                    :
                                        <p>{moment.utc(selectedWaveDate).format('ll')}</p>
                                    }                                    

                                    <label>Requested Change Reason</label>
                                    
                                    <Form.Control as="select" value={changeReason} onChange={(e) => setChangeReason(e.target.value)}>
                                        <option value="Select">Select</option>
                                        {changeReasonArr.map((item,index) => 
                                            <option value={item.ChangeRequestReasonID} key={index}>{item.Reason}</option>
                                        )}
                                    </Form.Control>
                                    <Form.Control className="request-reason" value={changeComment} onChange={(e) => setChangeComment(e.target.value)} placeholder="Why are you requesting this change..." />
                                   
                                </>
                            )}    
                            
                        </div>
                        <Button className="float-right" onClick={() => requestWaveChange()} disabled={((selectedWave === "Select" || changeReason === "Select") || ( changeComment.length < 5) || isRequesting)}>{isRequesting ? "Requesting..." : "Request"}</Button>
                        </>
                    )}

                    {hasPendingChange && (
                    <div className="mt-4 mb-2 change-request-box">
                        <p>Request pending:</p>
                        <label>Requested Wave</label>
                        <p>{selectedWave}</p>
     
                        <label>Requested Date</label>
                        <p>{moment.utc(selectedWaveDate).format('ll')}</p>

                        <label>Requestor</label>
                        <p>{changeRequestor}</p>

                        <label>Requested Change Reason</label>
                        <p>{changeReason}</p>

                        {changeRequestorGUID.toLowerCase() === user.localAccountId.toLowerCase() && (
                            <Button onClick={() => cancelRequest()} className="mt-3">Cancel Request</Button>
                        )}
                    </div>
                    )}
                   

                </div>            
            )}        
        </div>
    );
}